import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AdminMessages() {
    const [items, setItems] = useState([]);
    useEffect(() => {
        api.get("/admin/contact-messages").then((r) => setItems(r.data));
    }, []);

    return (
        <div className="p-8" data-testid="admin-messages">
            <h1 className="font-display text-3xl font-bold mb-1">Customer messages</h1>
            <p className="text-sm text-muted-foreground mb-8">{items.length} message{items.length !== 1 ? 's' : ''}</p>
            <div className="space-y-3">
                {items.map((m) => (
                    <div key={m.id} className="bg-white border border-border p-5">
                        <div className="flex justify-between items-start mb-2">
                            <div>
                                <div className="font-display font-bold">{m.subject}</div>
                                <div className="text-sm text-muted-foreground">{m.name} · {m.email} {m.phone ? `· ${m.phone}` : ''}</div>
                            </div>
                            <div className="text-xs text-muted-foreground">{new Date(m.created_at).toLocaleString()}</div>
                        </div>
                        {m.service_interest && <div className="text-xs text-primary font-semibold mb-2">Re: {m.service_interest}</div>}
                        <p className="text-sm whitespace-pre-wrap">{m.message}</p>
                    </div>
                ))}
                {items.length === 0 && <div className="bg-surface border border-border p-8 text-center text-muted-foreground">No messages yet.</div>}
            </div>
        </div>
    );
}
